import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../HomeView.vue';
import aboutUsView from '../aboutUsView.vue';
import servicesView from '../servicesView.vue';
import contactView from '../contactView.vue';

const routes = [
  { path: '/', component: HomeView },
  { path: '/about', component: aboutUsView},
  { path: '/services', component: servicesView},
  { path: '/contact', component: contactView},
  { path: '/:pathMatch(.*)*', redirect: '/' } // Redirect to home for any unmatched routes
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      // Si hay un hash en la ruta (como '#aboutView'),
      // lo utiliza como selector para desplazarse al elemento.
      return {
        el: to.hash, // O 'selector: to.hash' en versiones más antiguas
        behavior: 'smooth', // Desplazamiento suave (opcional)
      };
    } else if (savedPosition) {
      // Vuelve a la posición guardada (si se usa el botón de atrás/adelante del navegador)
      return savedPosition;
    } else {
      // Si no hay hash y no hay posición guardada,
      // desplázate a la parte superior de la página (o a la aplicación principal)
      return { top: 0 };
    }
  },
});



export default router;